<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(defineProps<{
  rating: number
  size?: 'sm' | 'md' | 'lg'
}>(), { size: 'md' })

const clamped = computed(() => Math.max(0, Math.min(5, props.rating)))
const fillWidth = computed(() => `${(clamped.value / 5) * 100}%`)
const ariaLabel = computed(() => `Ocena ${clamped.value.toFixed(1)} na 5`)
</script>

<template>
  <span class="star-rating" :class="`star-rating--${size}`" role="img" :aria-label="ariaLabel">
    <span class="star-rating__track" aria-hidden="true">★★★★★</span>
    <span
      class="star-rating__fill"
      data-testid="star-fill"
      aria-hidden="true"
      :style="{ width: fillWidth }"
    >★★★★★</span>
  </span>
</template>

<style scoped>
.star-rating {
  position: relative;
  display: inline-block;
  white-space: nowrap;
  line-height: 1;
}
.star-rating__track,
.star-rating__fill {
  letter-spacing: 0.1em;
}
.star-rating__track { color: var(--color-border); }
.star-rating__fill {
  position: absolute;
  inset: 0;
  overflow: hidden;
  color: var(--color-star);
}
.star-rating--sm { font-size: 0.8rem; }
.star-rating--md { font-size: 1rem; }
.star-rating--lg { font-size: 1.6rem; }
</style>
